import { CustomsMetadataResult } from 'utils/customs';

/**
 * The metadata a payment carries onto its collection transaction: what the merchant passed in `metadata`
 * (for example the lending SDK's `lendingApplicationReference`, which matches an equity payment to its loan
 * application), plus the customs assessment fields for customs payments. Keys and values are strings, as the
 * gateway stores them; anything else is dropped, and customs fields win over a merchant key of the same name.
 */
export const buildTransactionMetadata = (
  merchantMetadata: unknown,
  customs: CustomsMetadataResult,
): Record<string, string> | undefined => {
  const metadata: Record<string, string> = {};

  if (merchantMetadata && typeof merchantMetadata === 'object' && !Array.isArray(merchantMetadata)) {
    Object.entries(merchantMetadata as Record<string, unknown>).forEach(([key, value]) => {
      if (key.trim() === '') {
        return;
      }
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        metadata[key] = String(value);
      }
    });
  }

  if (customs.status === 'valid') {
    Object.assign(metadata, customs.metadata);
  }

  return Object.keys(metadata).length > 0 ? metadata : undefined;
};
